export default __webpack_public_path__ + "static/media/15.bb9e1705.jpg";